import React, { useEffect, useState } from 'react';
import { Content } from './components/index.js';

function App() {
  const [showButton, setShowButton] = useState(false);
  useEffect(() => {
    window.addEventListener("scroll", () => {
      if (window.pageYOffset > 300) {
        setShowButton(true);
      } else {
        setShowButton(false);
      }
    });
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <div className='app'>
      <h1 id="top">Anime Info Searcher</h1>

      <div>
        <Content />
      </div>
      {showButton && (
        <button onClick={scrollToTop} className="back-to-top">
          <p>&#5169;</p>
        </button>
      )}
    </div>
  );
}

export default App;
